import PropTypes from "prop-types";
import { Media } from "solar/components/Media";
import SurfSeasonDot from "components/shared/stays/SurfSeasonDot";
import styles from "components/shared/stays/SurfSeason.module.scss";

export default function SurfSeason({ season, oneLetter = false }) {
  const months = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];

  return (
    <div className={styles.component}>
      <div className={styles.season}>
        {season.map((month, index) => (
          <div key={months[index]} className={styles.month}>
            <div className={styles.text}>
              {oneLetter ? (
                <>{months[index].substring(0, 1)}</>
              ) : (
                <>
                  <Media lessThan="xl">{months[index].substring(0, 1)}</Media>
                  <Media greaterThan="lg">{months[index]}</Media>
                </>
              )}
            </div>
            <div className={styles.indicator}>
              <SurfSeasonDot season={month.toLowerCase()} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

SurfSeason.propTypes = {
  season: PropTypes.arrayOf(PropTypes.string).isRequired,
  oneLetter: PropTypes.bool,
};
